import { createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { RootState } from '../..';
import { saveOnboarding, getOnboarding } from './api';
import { setOnboardingUserIdToLocalStorage } from '../../../helper';

export interface IOnboardingUser {
  _id?: string;
  curriculum?: string;
  subject?: string;
  grade?: string;
  level?: string;
  hasTutoredBefore?: boolean;
  learningStyle?: string;
  goal?: string;
}

interface IOnboardingState {
  status: 'idle' | 'loading' | 'rejected';
  onboardingData?: IOnboardingUser;
}

const initialState: IOnboardingState = {
  status: 'idle',
  onboardingData: undefined,
};

export const OnboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    resetOnboardingData: (state) => {
      state.onboardingData = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOnboarding.fulfilled, (state, action) => {
        state.status = 'idle';
        state.onboardingData = action.payload;
      })
      .addCase(saveOnboarding.fulfilled, (state, action) => {
        state.status = 'idle';
        state.onboardingData = action.payload;
        if (action.payload._id) {
          setOnboardingUserIdToLocalStorage(action.payload._id);
        }
      });

    // Matchers
    builder
      .addMatcher(isPending(getOnboarding, saveOnboarding), (state) => {
        state.status = 'loading';
      })
      .addMatcher(isRejected(getOnboarding, saveOnboarding), (state) => {
        state.status = 'rejected';
      });
  },
});

export const { resetOnboardingData } = OnboardingSlice.actions;

export const getOnboardingState = (state: RootState): RootState['onboarding'] =>
  state.onboarding;

export * from './api';
export default OnboardingSlice.reducer;
